import { observable, action } from "mobx";

class OutlookOAuthState {
  @observable inboxId = null;

  @action
  setInboxId = (val = null) => {
    this.inboxId = val;
  };
}

const outlookOAuthState = new OutlookOAuthState();

export { outlookOAuthState };
export default outlookOAuthState;
